import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

import { ReactComponent as VideoPause } from '@/assets/icons/videoPause.svg';
import { ReactComponent as VideoPlay } from '@/assets/icons/videoPlay.svg';

export const VideoModal = styled(Box)`
  background-color: ${({ theme }) => theme.colors?.black};
  border-top: 3px solid ${({ theme }) => theme.colors?.goldenRod};
  bottom: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 999;
`;
export const CloseButton = styled(Box)`
  cursor: grab;
  top: 5px;
  right: 5px;
  position: absolute;
  z-index: 10;
`;
export const PlayerWrapper = styled(Box)`
  align-self: center;
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
`;
export const VideoBox = styled(Box)<{
  $currentTime?: number;
  $isEnded?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  ${({ $currentTime }) =>
    $currentTime !== 0 &&
    css`
      z-index: 1;
    `}
  ${({ $isEnded }) =>
    !!$isEnded &&
    css`
      z-index: unset;
    `}
`;
export const PlayerVideo = styled.video<{
  $aspectRatio?: { x: number; y: number };
  controls?: boolean;
}>`
  width: 100%;
  height: 100%;
  margin: 0 auto;
`;
export const VideoActionButton = styled.button`
  background: transparent;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 0;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 3;
`;

export const VideoPlayIcon = styled(VideoPlay)`
  &:hover {
    path:nth-child(2) {
      fill: ${({ theme }) => theme.colors?.primary};
      transition: fill 0.3s;
    }
    path:nth-child(1) {
      stroke: ${({ theme }) => theme.colors?.primary};
      transition: stroke 0.3s;
    }
  }
`;

export const VideoPauseIcon = styled(VideoPause)`
  &:hover {
    rect {
      fill: ${({ theme }) => theme.colors?.primary};
      transition: fill 0.3s;
    }
    path {
      stroke: ${({ theme }) => theme.colors?.primary};
      transition: stroke 0.3s;
    }
  }
`;

export const PlayerControls = styled(Box)`
  bottom: 0;
  display: flex;
  height: 3.5rem;
  opacity: 0.7;
  padding: 1rem;
  position: absolute;
  width: 100%;
  z-index: 10;
`;
export const StyledPlayAndPauseButton = styled.button`
  cursor: grab;
  background-color: #ddd;
  border: none;
  border-radius: 0;
  color: #000;
  flex: 1 auto;
  margin: 0;
  outline: none;
  padding: 0;
  text-align: center;
  width: 3rem;
  border-bottom-left-radius: 0.2em;
  border-top-left-radius: 0.2em;
`;
export const StyledMuteButton = styled.button`
  cursor: grab;
  background-color: #ddd;
  border: none;
  border-radius: 0;
  color: #000;
  flex: 1 auto;
  margin: 0;
  outline: none;
  padding: 0;
  text-align: center;
  width: 3rem;
`;
export const StyledToggleScreenButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: grab;
  background-color: #ddd;
  border: none;
  border-radius: 0;
  color: #000;
  flex: 1 auto;
  margin: 0;
  outline: none;
  padding: 0;
  text-align: center;
  width: 3rem;
  border-bottom-right-radius: 0.2em;
  border-top-right-radius: 0.2em;
`;
export const PlayersControlsProgressBar = styled(Box)`
  flex: 1 100%;
  position: relative;
`;
export const StyledProgress = styled.progress`
  cursor: grab;
  appearance: none;
  background-color: #666;
  border: none;
  box-shadow: inset -0.2em 0.2em 0.4em rgba(0, 0, 0, 0.2);
  color: ${({ theme }) => theme.colors?.goldenRod};
  height: 100%;
  position: absolute;
  width: 100%;
  ::-webkit-progress-value {
    background: ${({ theme }) => theme.colors?.goldenRod};
  }
`;
